
export default {
  submitText: '保存',
  emptyBtn: false,
  labelWidth: 120,
  column: [
    {
      label: '小区分组',
      prop: 'areaGroup',
      type: 'select',
      dicUrl: 'api/base/property/common/communityGroup',
      props: { label: 'dictValue', value: 'dictKey' },
      value: '1',
      rules: [
        {
          required: true,
          message: '小区分组',
          trigger: 'blur',
        },
      ],
      span: 12,
    },
    {
      label: '所属小区',
      prop: 'areaName',
      dicData: [],
      props: {
        label: "roomName",
        value: "roomName",
      },
      type: "tree",
      defaultExpandAll: true,
      // checkStrictly: true,
      multiple: true,
      rules: [
        {
          required: true,
          message: '请选择所属小区',
          trigger: 'blur',
        },
      ],
      span: 12,
    },

  ],
};
